import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { PermissionCodeEnum } from '/@/enums/permissionCodeEnum';
import { STORAGE_KEY } from '/@/constants/storage';

const dataset: AppRouteModule = {
  path: RouteEnum.MODELS,
  name: RouteEnum.MODELS,
  component: LAYOUT,
  redirect: RouteEnum.MODELS_LIST,
  meta: {
    hideChildrenInMenu: true,
    icon: 'models|svg',
    title: t('routes.models.models'),
    orderNo: 10,
    // hideMenu: true,
    permCode: [PermissionCodeEnum.MODEL_VIEW],
  },
  children: [
    {
      path: 'list',
      name: RouteEnum.MODELS_LIST,
      component: () => import('/@/views/models/list/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
    {
      path: 'detail',
      name: RouteEnum.MODELS_DETAIL,
      component: () => import('/@/views/models/detail/index.vue'),
      meta: {
        title: t('routes.models.details'),
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        // sessionInfo: STORAGE_KEY.breadcrumbType,
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.MODELS_LIST,
      },
    },
  ],
};

export default dataset;
